import { render, staticRenderFns } from "./OverlayAlarmButton.vue?vue&type=template&id=1685a778&scoped=true&"
import script from "./OverlayAlarmButton.vue?vue&type=script&lang=js&"
export * from "./OverlayAlarmButton.vue?vue&type=script&lang=js&"
import style0 from "./OverlayAlarmButton.vue?vue&type=style&index=0&id=1685a778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1685a778",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VIcon})
